import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('group_members',
  '/plans/group_members',
  'group_members')
const reducer = generator.generate()

export default reducer
